class UpgradesListController {

    constructor($state, access, messageService) {
        this.$state = $state;
        this.access = access;
        this.messageService = messageService;
    }

    $onInit () {
        this.matchEvents();
    }

    matchEvents () {
        this.matches = {
            treatment: [],
            spaday: []
        };
        this.upgrades.forEach(upgrade => {
            this.matches[upgrade.origin.type].push({
                originType: upgrade.origin.type,
                origin: this[`${upgrade.origin.type}s`].find(event => event.id === upgrade.origin.id),
                upgradeType: upgrade.upgrade.type,
                upgrade: this[`${upgrade.upgrade.type}s`].find(event => event.id === upgrade.upgrade.id)
            });
        });
    }

    createUpgrade () {
        if (!this.createEvent) {
            this.messageService.failure('Please select an event before creating an upgrade');
            this.messageService.push();
        }

        const name = this.createEvent.type_name.toLowerCase();
        if (name === 'treatment') {
            this.loading = true;
            return this.$state.go('app.admin.treatment-edit', { treatment: this.createEvent.id, tab: 'upgrade' });
        }
        if (name === 'spaday') {
            this.loading = true;
            return this.$state.go('app.admin.spaday-edit', { spaday: this.createEvent.id, tab: 'upgrade' });
        }

        this.messageService.failure('Could not create an upgrade for that event');
        this.messageService.push();
    }
}

UpgradesListController.$inject = ['$state', 'access', 'messageService'];

export default UpgradesListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/upgrades.list.controller.js